import { easepick } from '@easepick/core';
import { DateTime } from '@easepick/datetime';
import { LockPlugin } from '@easepick/lock-plugin';
import { TimePlugin } from '@easepick/time-plugin';
import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-datepicker' })
export class DatepickerComponent {
	private datePicker: easepick.Core;

	constructor(private element: HTMLInputElement) {
		const disabledWeekDays = this.element.getAttribute(
			'data-disabled-week-days'
		);
		const enableTime = this.element.getAttribute('data-enable-time');
		const plugins = [LockPlugin] as any;
		if (enableTime && enableTime == 'true') {
			plugins.push(TimePlugin);
		}
		this.datePicker = new easepick.create({
			element: this.element,
			css: ['/css/datepicker.css'],
			plugins: plugins,
			lang: document.documentElement.lang,
			zIndex: 999,
			format: 'DD.MM.YYYY',
			readonly: false,
			date: this.element.value,
			LockPlugin: {
				minDate: this.element.min,
				maxDate: this.element.max,
				filter(date: DateTime, picked: DateTime[]) {
					const isDisabled =
						disabledWeekDays &&
						disabledWeekDays.indexOf(date.getDay().toString()) !=
							-1;
					return isDisabled;
				},
			},
			setup(picker) {
				picker.on('select', (e) => {
					const event = new Event('change', {
						bubbles: false,
						cancelable: true,
					});
					this.element.dispatchEvent(event);
				});
			},
		});
		if (!this.element.value) {
			this.datePicker.gotoDate(this.element.min);
		}
	}
}
